export default "/static/516ed3b1e697829c.svg"